<template>
    <header class="comment-header">
        <div class="left">评论</div>
        <div class="right" v-if="!disabled">
            <img
                class="add-comment"
                src="~@/assets/add-comment-logo.png"
                alt=""
            />
            <span @click="goComment()">写评论</span>
        </div>
    </header>
</template>
<script>
    export default {
        name: "add-comment",
        props: ["disabled"],
        data() {
            return {
                id: "",
            };
        },
        mounted() {
            this.id = this.$route.params.id;
        },
        methods: {
            goComment() {
                this.$router.push(`/comment/${this.id}`);
            },
        },
    };
</script>

<style lang="scss" scoped src="./add-comment.scss"></style>
